import {
  PosVendaProtocoloOrigem,
  PosVendaProtocoloPrioridade,
  PosVendaProtocoloStatus,
  PosVendaProtocoloTipo,
} from '../../types/posVenda';
import { getTipoDemandaLabel, TIPO_DEMANDA_CATALOGO } from './posVendaTipoCatalog';

export function labelTipoProtocolo(tipo: PosVendaProtocoloTipo): string {
  return getTipoDemandaLabel(tipo);
}

/** Mapa para filtros e compat — inclui catálogo + legado. */
export const PROTOCOLO_TIPO_LABEL: Record<PosVendaProtocoloTipo, string> = (() => {
  const map = {} as Record<PosVendaProtocoloTipo, string>;
  TIPO_DEMANDA_CATALOGO.forEach((e) => {
    map[e.tipo] = e.label;
  });
  const legacy: PosVendaProtocoloTipo[] = [
    'Reativacao',
    'EnvioTrocaChip',
    'Reclamacao',
    'Outros',
  ];
  legacy.forEach((t) => {
    map[t] = getTipoDemandaLabel(t);
  });
  return map;
})();

export const PROTOCOLO_STATUS_LABEL: Record<PosVendaProtocoloStatus, string> = {
  Aberto: 'Aberto',
  EmAnalise: 'Em análise',
  AguardandoCliente: 'Aguardando cliente',
  AguardandoTerceiro: 'Aguardando terceiro',
  EmExecucao: 'Em execução',
  Concluido: 'Concluído',
  Cancelado: 'Cancelado',
};

export const PROTOCOLO_ORIGEM_LABEL: Record<PosVendaProtocoloOrigem, string> = {
  Telefone0800: '0800',
  Telefone: 'Telefone',
  Email: 'E-mail',
  Interno: 'Interno',
  WhatsApp: 'WhatsApp',
  Supervisor: 'Supervisor (legado)',
};

/** Origens disponíveis na criação. */
export const PROTOCOLO_ORIGENS_CRIACAO: PosVendaProtocoloOrigem[] = [
  'Telefone0800',
  'Telefone',
  'Email',
  'WhatsApp',
  'Interno',
];

export const PROTOCOLO_PRIORIDADE_LABEL: Record<PosVendaProtocoloPrioridade, string> = {
  Baixa: 'Baixa',
  Normal: 'Normal',
  Alta: 'Alta',
};

export const PROTOCOLO_TIPOS: PosVendaProtocoloTipo[] = TIPO_DEMANDA_CATALOGO.map((e) => e.tipo);

export const PROTOCOLO_STATUS_ATIVOS: PosVendaProtocoloStatus[] = [
  'Aberto',
  'EmAnalise',
  'AguardandoCliente',
  'AguardandoTerceiro',
  'EmExecucao',
];
